import React, { useState, useEffect } from "react";
import "./styles.scss";
import { Box, MobileStepper, Paper, Typography, Button } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { KeyboardArrowLeft, KeyboardArrowRight } from "@mui/icons-material";
import ProductDetailPage from "./details";

import {
  getProductDetails,
  postSingleProductAdded,
  getCartList,
} from "../../store/homeAction/action";
import { ReactComponent as Backbtn } from "../../assets/icons/backbtn.svg";
import { useNavigate } from "react-router-dom";

import { useStateValue } from "../../store/index";

const TextMobileStepper = () => {
  //state value fron store
  const [{ productDetailData }, dispatch] = useStateValue();

  //state
  const [productData, setProductData] = useState([]);
  const [allSelectedVariant, setAllSelectedVariant] = useState({});

  const theme = useTheme();
  const [activeStep, setActiveStep] = useState(
    parseInt(sessionStorage.getItem("product_index"))
      ? parseInt(sessionStorage.getItem("product_index"))
      : 0
  );
  const maxSteps = productDetailData?.product_details?.length;
  const Navigate = useNavigate();

  //get product details
  useEffect(() => {
    dispatch({
      type: "SET_IS_LOADING",
      value: true,
    });
    let tempData = JSON.parse(sessionStorage.getItem("bundle_detail"));
    let arr = [];
    tempData?.map((item) => {
      arr.push(item?.product_id);
    });
    const payload = {
      product_ids: arr,
    };
    getProductDetails((res, error) => {
      dispatch({
        type: "SET_PRODUCT_DETAILS",
        data: res,
      });
      dispatch({
        type: "SET_IS_LOADING",
        value: false,
      });
      if (error) {
        dispatch({
          type: "SET_ALERT_MESSAGE",
          value: true,
          data: {
            severity: "error",
            message: "Something went wrong, Please try again.",
          },
        });
      }
    }, payload);
  }, []);

  //steps slider changes
  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };
  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  //remake the getProductDetail changes
  useEffect(() => {
    if (productDetailData?.product_details?.length) {
      let temp = productDetailData.product_details.map((item) => {
        const tempData = {};
        item?.attributes?.length &&
          item?.attributes?.forEach((i) => {
            const keyName = `${i?.attribute_name}__${i?.attribute_type || ""}`;
            tempData[keyName] = tempData[keyName] || [];
            tempData[keyName].push(i?.options);
          });
        return { ...item, attributes: tempData };
      });
      setProductData(temp);
    }
  }, [productDetailData?.product_details]);

  //get variant with price
  const handleSelectedVariant = (value) => {
    const temp = { ...allSelectedVariant };
    temp[value.index] = value.selectedVariant;
    const arrayOfObjects = Object.entries(temp).map(([key, value]) => ({
      key,
      ...value,
    }));
    setAllSelectedVariant(arrayOfObjects);

    sessionStorage.setItem("product_details", JSON.stringify(arrayOfObjects));
  };

  const defaultSelectVariant = {};
  const handleDefaultVariant = (value) => {
    defaultSelectVariant[value.index] = value.selectedVariant;
    setTimeout(() => {
      const arrayOfObjects = Object.entries(defaultSelectVariant).map(
        ([key, value]) => ({
          key,
          ...value,
        })
      );
      setAllSelectedVariant(arrayOfObjects);
      sessionStorage.setItem("product_details", JSON.stringify(arrayOfObjects));
    }, 100);
  };
  const handleAddCart = () => {
    let sessionKey = sessionStorage.getItem("session_key");
    let userBundle = JSON.parse(sessionStorage.getItem("user_bundle"));
    let payload = {
      terms: userBundle?.title,
      product_id: allSelectedVariant?.[activeStep]?.product_id,
      variation_id: allSelectedVariant?.[activeStep]?.variation_id,
    };
    payload.session_key = sessionKey ?? null;
    dispatch({
      type: "SET_IS_LOADING",
      value: true,
    });
    postSingleProductAdded((res, error) => {
      if (res?.datas?.session_key) {
        sessionStorage.setItem("session_key", res?.datas?.session_key);
      }
      dispatch({
        type: "SET_CART_ALERT",
        value: true,
        data: {
          identity: "single",
          ...res?.datas,
          message: res?.message,
          ...error?.data,
        },
      });
      let payload = {
        session_key: sessionStorage.getItem("session_key"),
      };
      getCartList((res) => {
        dispatch({
          type: "SET_CARTLIST_DATA",
          data: res,
        });
        sessionStorage.setItem(
          "iszipAuth",
          res?.data?.installation_content?.postal_code
        );
        dispatch({
          type: "SET_ZIP_CODE_POPUP",
          value: false,
          data: {
            installation: res?.data?.installation_content?.installation,
            fall_prevention: res?.data?.installation_content?.fall_prevention,
            zipCode: res?.data?.installation_content?.postal_code,
          },
        });
        dispatch({
          type: "SET_IS_LOADING",
          value: false,
        });
      }, payload);
    }, payload);
  };

  return (
    <Box className="product-detail-silder-container">
      {productDetailData?.product_details?.length ? (
        <>
          <Backbtn onClick={() => Navigate(-1)} className="back-btn" />
          <div className="title-container">
            <Paper
              square
              elevation={0}
              sx={{
                display: "flex",
                alignItems: "center",
                bgcolor: "background.default",
              }}
            >
              <Typography>
                {productDetailData?.product_details[activeStep]?.product_name}
              </Typography>
            </Paper>
            <MobileStepper
              variant="text"
              steps={maxSteps}
              position="static"
              activeStep={activeStep}
              className="stepper"
              nextButton={
                <Button
                  size="small"
                  onClick={handleNext}
                  disabled={activeStep === maxSteps - 1}
                  className="btn"
                  disableRipple
                >
                  {theme.direction === "rtl" ? (
                    <KeyboardArrowLeft />
                  ) : (
                    <KeyboardArrowRight />
                  )}
                </Button>
              }
              backButton={
                <Button
                  size="small"
                  onClick={handleBack}
                  disabled={activeStep === 0}
                  className="btn"
                  disableRipple
                >
                  {theme.direction === "rtl" ? (
                    <KeyboardArrowRight />
                  ) : (
                    <KeyboardArrowLeft />
                  )}
                </Button>
              }
            />
          </div>

          <Box sx={{ width: "100%" }}>
            {productData?.length &&
              productData.map((itm, index) => {
                return (
                  <ProductDetailPage
                    data={itm}
                    index={index}
                    activeStep={activeStep}
                    description={productDetailData?.additional_content?.[0]}
                    handleSelectedVariant={handleSelectedVariant}
                    handleDefaultVariant={handleDefaultVariant}
                    handleAddCart={handleAddCart}
                    allSelectedVariant={allSelectedVariant}
                    key={`ProductDetailPage_${index}`}
                  />
                );
              })}
          </Box>
        </>
      ) : (
        ""
      )}
    </Box>
  );
};

export default TextMobileStepper;
